{
  "version": 1,
  "asset_id": "77e936ed-fb19-4548-a762-a7da115976f7",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/77e936ed-fb19-4548-a762-a7da115976f7/hiatal-normal-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/77e936ed-fb19-4548-a762-a7da115976f7/hiatal-normal-800.jpg",
  "original_filename": "hiatal-normal-800.jpg",
  "size": 62475,
  "content_type": "image/jpeg",
  "created_at": "2026-09-23T01:03:49Z"
}
